var chunkMapping = {
	"1": [
		6571
	],
	"53": [
		3273,
		7413
	],
	"61": [
		9245,
		8929
	],
	"66": [
		5114,
		55
	],
	"97": [
		3006,
		1106
	],
	"218": [
		8885,
		9310
	],
	"221": [
		4007,
		5715
	],
	"222": [
		1458,
		9107
	],
	"238": [
		3015,
		1128
	],
	"283": [
		7941,
		9159
	],
	"380": [
		6004,
		3387
	],
	"398": [
		9375,
		7000
	],
	"413": [
		101,
		2721
	],
	"426": [
		5769,
		8722
	],
	"468": [
		1543,
		2126
	],
	"475": [
		1056,
		9662
	],
	"490": [
		7825,
		9786
	],
	"510": [
		3246,
		6553
	],
	"520": [
		4946,
		1241
	],
	"589": [
		1791,
		3783
	],
	"755": [
		1161,
		2963
	],
	"804": [
		1506,
		279
	],
	"805": [
		1078,
		7336
	],
	"816": [
		2964,
		3029
	],
	"851": [
		7531,
		4737
	],
	"871": [
		4987,
		3469
	],
	"895": [
		1214,
		2050
	],
	"921": [
		3543,
		2439
	],
	"928": [
		7275,
		2958
	],
	"979": [
		2722,
		8126
	]
};
var idToExternalAndNameMapping = {
	"55": [
		"default",
		"./ProductShowcase",
		5426
	],
	"101": [
		"default",
		"./IntegrationHub",
		5170
	],
	"279": [
		"default",
		"./push_v0",
		2166
	],
	"1056": [
		"default",
		"./technicalPushes_v0",
		2166
	],
	"1078": [
		"default",
		"./Audit",
		760
	],
	"1106": [
		"default",
		"./MobileHeader",
		9322
	],
	"1128": [
		"default",
		"./Transfers",
		1662
	],
	"1161": [
		"default",
		"./validations",
		9322
	],
	"1214": [
		"default",
		"./Profile",
		2066
	],
	"1241": [
		"default",
		"./GlobalStore",
		9174
	],
	"1458": [
		"default",
		"./Modal",
		9322
	],
	"1506": [
		"default",
		"./notification_v2",
		2166
	],
	"1543": [
		"default",
		"./TransferQRScan",
		1626
	],
	"1791": [
		"default",
		"./BottomMenu",
		9322
	],
	"2050": [
		"default",
		"./SigningDocumentsPage",
		3050
	],
	"2126": [
		"default",
		"./ActionSheet",
		9322
	],
	"2439": [
		"default",
		"./OperationsHistory",
		936
	],
	"2721": [
		"default",
		"./LocalizationDictionary",
		6738
	],
	"2722": [
		"default",
		"./ButtonFlat",
		9322
	],
	"2958": [
		"default",
		"./Dialogs",
		8474
	],
	"2963": [
		"default",
		"./WebAuthnStore",
		586
	],
	"2964": [
		"default",
		"./InputOrdinaryComponent",
		9322
	],
	"3006": [
		"default",
		"./Loader",
		9322
	],
	"3015": [
		"default",
		"./SplashesPage",
		5566
	],
	"3029": [
		"default",
		"./InputPinCode",
		9322
	],
	"3246": [
		"default",
		"./DesktopHeader",
		9322
	],
	"3273": [
		"default",
		"./BillboardSuspenseLoader",
		108
	],
	"3387": [
		"default",
		"./Partner",
		3142
	],
	"3469": [
		"default",
		"./RightSheetComponent",
		9322
	],
	"3543": [
		"default",
		"./MainSuspenseLoader",
		3560
	],
	"3783": [
		"default",
		"./BottomSheet",
		9322
	],
	"4007": [
		"default",
		"./OperationHistorySuspenseLoader",
		108
	],
	"4737": [
		"default",
		"./ButtonBanner",
		9322
	],
	"4946": [
		"default",
		"./GlobalDataLoader",
		4342
	],
	"4987": [
		"default",
		"./PageLoader",
		9322
	],
	"5114": [
		"default",
		"./Privilege",
		9472
	],
	"5715": [
		"default",
		"./SigningDocumentsSuspenseLoader",
		108
	],
	"5769": [
		"default",
		"./hooks",
		9322
	],
	"6004": [
		"default",
		"./TransfersSuspenseLoader",
		108
	],
	"6553": [
		"default",
		"./DesktopPinCodeScreen",
		9322
	],
	"6571": [
		"default",
		"./hoc",
		9322
	],
	"7000": [
		"default",
		"./Icon",
		9322
	],
	"7275": [
		"default",
		"./hook",
		50
	],
	"7336": [
		"default",
		"./useSearchParamsValue",
		8133
	],
	"7413": [
		"default",
		"./LoyaltyProgramsLoader",
		108
	],
	"7531": [
		"default",
		"./Button",
		9322
	],
	"7825": [
		"default",
		"./LoyaltyPrograms",
		4078
	],
	"7941": [
		"default",
		"./getPartnerResource",
		3142
	],
	"8126": [
		"default",
		"./Content",
		9322
	],
	"8722": [
		"default",
		"./utils",
		9322
	],
	"8885": [
		"default",
		"./Informer",
		9322
	],
	"8929": [
		"default",
		"./StatusScreen",
		9322
	],
	"9107": [
		"default",
		"./NotificationToast",
		9322
	],
	"9159": [
		"default",
		"./withPartner",
		3142
	],
	"9245": [
		"default",
		"./Segmented",
		9322
	],
	"9310": [
		"default",
		"./InputCode",
		9322
	],
	"9375": [
		"default",
		"./GuideBanner",
		9322
	],
	"9662": [
		"default",
		"./authorization_v4",
		2166
	],
	"9786": [
		"default",
		"./Main",
		3560
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}